
/* eslint-disable no-undef */
import studioQuery from '~/apollo/queries/studio'

export default {
  layout: 'studioPages',
  async asyncData ({ $graphql }) {
    const data = await $graphql.default.request(studioQuery)
    return {
      data: data.page
    }
  },
  data () {
    return {
      loading: 0,
      marquee: null
    }
  },
  head () {
    return {
      title: this.metaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaDesc
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://studio375.it/media/logo-studio375.png'
        },
        {
          hid: 'og:image:width',
          property: 'og:image:width',
          content: '1200'
        },
        {
          hid: 'og:image:height',
          property: 'og:image:height',
          content: '630'
        },
        {
          hid: 'og:image:type',
          property: 'og:image:type',
          content: 'image/png'
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.metaTitle
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: 'https://studio375.it' + this.path
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.metaDesc
        },
        {
          hid: 'og:locale',
          property: 'og:locale',
          content: 'it_IT'
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'Studio375'
        }
      ],
      bodyAttrs: {
        class: 'studio'
      }
    }
  },
  computed: {
    path () {
      if (this.$route.path.charAt(this.$route.path.length - 1) === '/') {
        return this.$route.path
      } else {
        return this.$route.path + '/'
      }
    },
    h1 () {
      return (this.data.dettagli_studio) ? this.data.dettagli_studio.h1 : ''
    },
    title () {
      return (this.data.title) ? this.data.title : ''
    },
    sub () {
      return (this.data.dettagli_studio) ? this.data.dettagli_studio.sottotitolo : ''
    },
    paragrafo () {
      return (this.data.dettagli_studio) ? this.data.dettagli_studio.paragrafo : ''
    },
    clienti () {
      return (this.data.dettagli_studio) ? this.data.dettagli_studio.clienti : ''
    },
    riconoscimenti () {
      return (this.data.dettagli_studio) ? this.data.dettagli_studio.riconoscimenti : ''
    },
    // marquee () {
    //   return (this.data.dettagli_studio) ? this.data.dettagli_studio.marquee : null
    // },
    metaDesc () {
      return this.$store.getters.getSeoByID(229).metaDesc
    },
    metaTitle () {
      return this.$store.getters.getSeoByID(229).title
    }
  },
  mounted () {
    this.marquee = this.data.dettagli_studio.marquee
  },
  methods: {
  }
}
